import {isProperty} from 'libs/utils/utils';

import {ApplicationStoreType} from 'reducers';

import {MODULE_KEY} from '../../../constants';
import {OrderDataType} from '../../reducers/orderData/orderDataType';

/**
 * Returns order id and redirect url
 * @param {ApplicationStoreType} store - Current store
 * @returns {OrderDataType} - saved order status
 */
export const getOrderData = (store: ApplicationStoreType): OrderDataType =>
    store[MODULE_KEY].orderData;

/**
 * Returns order id and redirect url
 * @param {ApplicationStoreType} store - Current store
 * @returns {{id: string, url: string}} - Stored order id
 */
export const getOrderId = (store: ApplicationStoreType): {id: string; url: string} => ({
    id: store[MODULE_KEY].orderData.orderId,
    url: store[MODULE_KEY].orderData.redirectUrl,
});

/**
 * Returns order id and redirect url
 * @param {ApplicationStoreType} store - Current store
 * @returns {boolean} - saved order status
 */
export const isSavedOrderPending = (store: ApplicationStoreType): boolean =>
    store[MODULE_KEY].orderData.status === 'pending';
/**
 * Returns the user selection for subscribe newsletter
 * @param {ApplicationStoreType} store - Current order review
 * @returns {boolean} - subscription user to the newsletter
 */
export const getSubscribeNewsletter = (store: ApplicationStoreType): boolean =>
    store[MODULE_KEY].orderData.isSubscribed;

/**
 * Is order data fulfilled
 * @param {ApplicationStoreType} - application store
 * @returns {boolean} - is fulfilled
 */
export const isOrderDataFulfilled = isProperty(`${MODULE_KEY}.orderData.status`, 'fulfilled');
